/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { UserLoginResponse } from './UserLoginResponse';
const OTPLoginSingleResponseParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('login')],
]), UserLoginResponse);
export class OTPLoginSingleResponse extends UserLoginResponse {
    static decode(input) {
        return OTPLoginSingleResponseParser.decode(input).map(res => new OTPLoginSingleResponse(res));
    }
    static unsafeDecode(input) {
        return OTPLoginSingleResponse.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return OTPLoginSingleResponseParser.encode(data);
    }
    static schema() {
        return OTPLoginSingleResponseParser.schema();
    }
}
